import { QuestionAddForm } from 'mk2/apps/strollers/containers/StrollerAddQuestion/QuestionAddForm';
import { Props } from 'mk2/apps/strollers/containers/StrollerAddQuestion/StrollerAddQuestionPage';
import React from 'react';
import styles from './StrollerAddQuestion.mscss';

export class StrollerAddQuestion extends React.Component<Props> {

    public render() {
        const { isMobile, initialValues, slug, onSave } = this.props;

        return (
            <div className={styles.StrollerAddQuestion}>
                <QuestionAddForm
                    initialValues={initialValues}
                    isMobile={isMobile}
                    slug={slug}
                    onSave={onSave}
                />
            </div>
        );
    }
}
